import { ShopsApiClient } from '@fourthwall/services/dist/ShopsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUpdateShopMutation = createMutationHook(ShopsApiClient.updateShop, {
  mutationKey: ['updateShop'],
})
